import { HttpClient }  from '@angular/common/http';
import {
  Inject,
  Injectable,
}                      from '@angular/core';
import { Observable }  from 'rxjs';
import { ENVIRONMENT } from '../app.constants';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagApiService {
  constructor(
    @Inject(ENVIRONMENT)
    private readonly environment: Environment,
    private readonly http: HttpClient,
  ) {
  }

  fetchNewBudgetAppEnabled(): Observable<boolean> {
    return this.http.get<boolean>(`${this.environment.api}/unleash/NEW_BUDGET_APP`);
  }
}
